import { render, staticRenderFns } from "./update-price.vue?vue&type=template&id=7628719b&"
import script from "./update-price.vue?vue&type=script&lang=js&"
export * from "./update-price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports